import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  ViewEncapsulation,
  input,
  InputSignal,
  effect,
  Renderer2,
  ElementRef,
  computed,
  Signal,
  RendererStyleFlags2,
  inject,
} from '@angular/core';
import { findSubjectIcon, LyceoSubjectIcon } from '@lyceo/shared/util';

import { SubjectIconShape } from '@lyceo/shared/util-models';

@Component({
  selector: 'lyceo-subject-icon',
  imports: [],
  templateUrl: './subject-icon.component.html',
  styleUrls: ['./subject-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class SubjectIconComponent {
  private readonly renderer: Renderer2 = inject(Renderer2);
  private readonly elementRef: ElementRef = inject(ElementRef);

  public subjectName: InputSignal<string | undefined> = input<
    string | undefined
  >();
  public shape: InputSignal<SubjectIconShape> = input<SubjectIconShape>(
    SubjectIconShape.NONE,
  );

  protected icon: Signal<LyceoSubjectIcon> = computed(() =>
    findSubjectIcon(this.subjectName()),
  );

  constructor() {
    effect(() => {
      this.renderer.setStyle(
        this.elementRef.nativeElement,
        '--trix-subject-icon-background-color',
        `var(--trix-${this.icon().cssVarDark})`,
        RendererStyleFlags2.DashCase,
      );
    });
  }

  @HostBinding('class.lyceo-subject-icon')
  public get lyceoPractiseCard(): boolean {
    return true;
  }

  @HostBinding('class.shape-none')
  public get none(): boolean {
    return this.shape() === SubjectIconShape.NONE;
  }

  @HostBinding('class.shape-round')
  public get round(): boolean {
    return this.shape() === SubjectIconShape.ROUND;
  }
}
